import React, { Component, createRef } from 'react';
import { Card, CardBody, Col, Label } from 'reactstrap';
import { connect } from 'react-redux';
import StaffTableComponent from './StaffTableComponent';
import Pagination from '../../shared/components/pagination/Pagination';
import {
  getStaffList,
  getAllFacilities,
  getAllDesignations,
  addNewStaffMember,
  updateStaffStatus,
  reinviteStaff,
} from '../../redux/actions/staffActions';
import {
  toggleMessageModel,
  toggleLoading,
} from '../../redux/actions/commonActions';
import ViewStaff from './ViewStaff';
import MessageModal from '../../shared/components/Modals/MessageModal';
import localStorage from '../../libs/storageHelper';
import config from '../../config/app.config';
import HeadingText from '../../shared/components/form/HeadingText';
import responseMessages from '../../constants/responseMessages';
import defaultStaffColumns, { facilityColumn } from './constants';
import StandardTableToolbar from '../../shared/components/table-toolbar/StandardTableToolbar';
import {
  STAFF_FILTER_SEARCH_THRESHOLD,
  getStaffFilterCategories,
  getStaffSortOptions,
} from './staffToolbarConfig';
import { isPrimaryAdmin, isSuperAdmin } from '../../utils/Utils';
import constants from '../../constants/constants';
import AddNewStaffModal from './AddNewStaffModal';
const { STATUS } = constants;

const buildFacilityOptions = (facilities = []) => {
  return [
    <option key="" value="">
      Select
    </option>,
  ].concat(
    facilities.map((value) => (
      <option
        key={value.id}
        value={value.id}
        disabled={value.status === STATUS.INACTIVE}
      >
        {value.name}
      </option>
    )),
  );
};

class Staff extends Component {
  searchRef = createRef();

  constructor() {
    super();
    const loggedUser = localStorage.getFromStorage('loggedUser').user;
    const facilities =
      loggedUser.type === config.USER_TYPES.SUPER_ADMIN
        ? []
        : [loggedUser.facility];

    this.modalTimeOutRef = null;
    this.successPauseTimeoutRef = null;
    this.state = {
      isInvite: true,
      staff: [],
      filters: {
        search: '',
        facilities,
        offset: 0,
        limit: config.DEFAULT_PAGINATION_LENGTH,
        total: 0,
        status: [],
        designation: [],
        type: [],
        privateCredentials: [],
        sortField: isSuperAdmin(loggedUser)
          ? 'facilityDisplayName'
          : 'fullName',
        sortOrder: 1,
      },
      modal: false,
      staffColumns: defaultStaffColumns,
      facilityOptions: [],
      error: false,
      successResponse: null,
      errorResponse: null,
      refreshState: true,
      selectedId: null,
      selectedMember: {},
      viewPopup: false,
      confirmPopup: {
        showResponse: false,
        responseMessage: '',
        responseType: '',
        responseAlertType: '',
        memberId: null,
        status: null,
        footer: false,
      },
      loggedUser,
    };
  }

  componentDidMount() {
    const { loggedUser } = this.state;
    if (loggedUser.type === config.USER_TYPES.SUPER_ADMIN) {
      this.props.getAllFacilities();
    }
    this.props.getStaffList(this.state.filters);
    this.props.getAllDesignations();
  }

  getCurrentUserFacilityOption = (props) => {
    if (!props.currentFacility) return [];

    return [
      {
        name: props.currentFacility.name,
        id: props.currentFacility._id,
      },
    ];
  };

  UNSAFE_componentWillReceiveProps(np) {
    if (np.staffList) {
      this.setState({
        filters: {
          ...this.state.filters,
          total: np.staffList.total,
          limit: np.staffList.perPage,
          offset: (np.staffList.page - 1) * np.staffList.perPage,
        },
        viewPopup: false,
      });

      if (isSuperAdmin(this.state.loggedUser)) {
        const staffColumns = [...defaultStaffColumns];
        staffColumns.splice(0, 0, facilityColumn);

        this.setState({
          staffColumns,
        });
      }
    }

    this.setState({
      facilityOptions: buildFacilityOptions(
        np.facilityAll || this.getCurrentUserFacilityOption(np),
      ),
    });

    if (np.newStaffResponse) {
      const { isInvite } = this.state;
      const { SUCCESS } = responseMessages;

      const successResponse = isInvite
        ? SUCCESS.MEMBER_INVITATION_SENT
        : SUCCESS.MEMBER_ADDED;

      this.setState({ successResponse, errorResponse: null });
      this.closeModalWithTimeOut();
    }
    if (np.newStaffErrorResponse) {
      if (np.newStaffErrorResponse.errorMessage) {
        this.setState({
          errorResponse: np.newStaffErrorResponse.errorMessage,
          successResponse: null,
        });
      }
    }
    if (np.staffUpdateStatus) {
      const { confirmPopup } = this.state;
      let responseMessage = '';
      switch (confirmPopup.status) {
        case 'active':
          responseMessage = 'Staff Profile activated successfully.';
          break;
        case 'inactive':
          responseMessage = 'Staff Profile deactivated successfully.';
          break;
        case 'removed':
          responseMessage = 'Staff Profile removed successfully.';
          break;
        default:
          break;
      }
      if (this.successPauseTimeoutRef) {
        clearTimeout(this.successPauseTimeoutRef);
      }
      this.successPauseTimeoutRef = setTimeout(() => {
        confirmPopup.showResponse = true;
        confirmPopup.responseMessage = responseMessage;
        confirmPopup.responseType = 'alert';
        confirmPopup.responseAlertType = 'success';
        confirmPopup.footer = true;
        this.setState({ confirmPopup }, function () {
          this.props.getStaffList(this.state.filters);
        });
      }, 400);
    }
    if (np.staffReinviteStatus) {
      const { confirmPopup } = this.state;
      if (this.successPauseTimeoutRef) {
        clearTimeout(this.successPauseTimeoutRef);
      }
      this.successPauseTimeoutRef = setTimeout(() => {
        confirmPopup.showResponse = true;
        confirmPopup.responseMessage = 'Invitation resent successfully.';
        confirmPopup.responseType = 'alert';
        confirmPopup.responseAlertType = 'success';
        confirmPopup.footer = true;
        this.setState({ confirmPopup }, function () {
          this.props.getStaffList(this.state.filters);
        });
      }, 400);
    }
    if (np.updateStaffResponse) {
      this.props.getStaffList(this.state.filters);
    }
  }

  componentDidUpdate(np) {
    if (np.common.loading) {
      this.props.toggleLoading(false);
    }
  }

  closeModalWithTimeOut = () => {
    this.modalTimeOutRef = setTimeout(() => {
      this.closeModal();
    }, config.NEW_STAFF_POPUP_TIMEOUT_TIME);
  };

  closeViewStaff = () => {
    this.setState({
      viewPopup: false,
      selectedId: null,
    });
  };

  viewProfile = (selectedMember) => {
    this.setState({
      selectedId: selectedMember.id,
      viewPopup: true,
      selectedMember,
    });
  };

  nextPage = () => {
    const { filters } = this.state;
    filters.offset = parseInt(filters.offset + filters.limit);
    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

  prevPage = () => {
    const { filters } = this.state;
    filters.offset = parseInt(filters.offset - filters.limit);
    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

handleSearch = (search) => {
  const { filters } = this.state;
  filters.search = search;
  filters.offset = 0;
  this.setState({ filters }, () => {
    this.props.getStaffList(filters);
  });
};

handleToolbarSort = ({ field, order }) => {
  const { filters } = this.state;
  filters.sortField = field ?? filters.sortField;
  filters.sortOrder = order ?? filters.sortOrder;
  filters.offset = 0;
  this.setState({ filters }, () => {
    this.props.getStaffList(filters);
  });
};

handleToolbarFilter = (filterType, values) => {
  const { filters } = this.state;
  filters[filterType] = values;
  filters.offset = 0;
  this.setState({ filters }, () => {
    this.props.getStaffList(filters);
  });
};

handleClearAllToolbarFilters = () => {
  const { filters, loggedUser } = this.state;
  filters.designation = [];
  filters.type = [];
  filters.privateCredentials = [];
  filters.status = [];
  if (isSuperAdmin(loggedUser)) {
    filters.facilities = [];
  }
  filters.offset = 0;
  this.setState({ filters }, () => {
    this.props.getStaffList(filters);
  });
};

  handleGridFilter = (header, value) => {
    const { filters } = this.state;
    if (header === 'facilities') {
      filters.facilities = value;
    } else {
      filters.status = value;
    }
    filters.offset = 0;
    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

  handlePageLimit = (perPage) => {
    const { filters } = this.state;
    filters.limit = perPage;
    filters.offset = 0;
    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

  gotoPage = (i) => {
    const { filters } = this.state;
    filters.offset = parseInt(filters.limit * i);
    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

  onSubmit = (staff) => {
    this.props.toggleLoading(true);
    this.setState({ isInvite: staff.privateCredentials });
    this.props.addNewStaffMember(staff);
  };

  closeModal = () => {
    if (this.modalTimeOutRef) {
      clearTimeout(this.modalTimeOutRef);
    }
    this.setState({
      modal: false,
      successResponse: null,
      errorResponse: null,
      selectedId: null,
      viewPopup: false,
    });
    this.props.getStaffList(this.state.filters);
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      error: false,
      successResponse: null,
      errorResponse: null,
      selectedId: null,
      viewPopup: false,
    });
  };

  handleGridSort = (field) => {
    const { filters } = this.state;
    const order = filters.sortOrder === 1 ? -1 : 1;
    filters.sortField = field;
    filters.sortOrder = order;

    this.setState({ filters }, () => {
      this.props.getStaffList(filters);
    });
  };

  handleActiveStatus = (status, id, firstName) => {
    let statusMessage = '';
    let confirmType = 'change_status';
    switch (status) {
      case 'active':
        statusMessage = 'Activate this Staff Profile?';
        break;
      case 'inactive':
        statusMessage = 'Deactivate this Staff Profile?';
        break;
      case 'removed':
        statusMessage = 'Remove this Staff Profile?';
        break;
      case 'reinvite':
        statusMessage = `Resend Invite to ${firstName}?`;
        confirmType = 'reinvite';
        break;
      default:
        break;
    }
    const confirmPopup = {
      showResponse: true,
      responseMessage: statusMessage,
      responseType: 'confirm',
      responseAlertType: null,
      staffId: id,
      footer: true,
      confirmType,
      status,
    };
    this.setState({ confirmPopup, showResponse: true });
  };

  onSuccess = () => {
    const { confirmPopup } = this.state;
    if (confirmPopup.confirmType === 'change_status') {
      this.props.updateStaffStatus(confirmPopup.staffId, {
        id: confirmPopup.staffId,
        status: confirmPopup.status,
      });
    } else if (confirmPopup.confirmType === 'reinvite') {
      this.props.reinviteStaff({ id: confirmPopup.staffId });
    }

    confirmPopup.showResponse = false;
    this.setState({ showResponse: false, confirmPopup });
  };

  handleClearSearch = () => {
    const newFilter = { ...this.state.filters, search: '' };

    this.setState({ filters: newFilter }, () => {
      this.props.getStaffList(newFilter);
    });
  };

  closePopup = () => {
    const { confirmPopup } = this.state;
    let { refreshState } = this.state;
    confirmPopup.showResponse = false;
    refreshState = !refreshState;
    this.setState({ confirmPopup, refreshState });
  };

  render() {
    const {
      facilityAll = [],
      staffList: { staff = [] },
      designationAll = [],
    } = this.props;

    const {
      successResponse,
      errorResponse,
      loggedUser,
      viewPopup,
      selectedId,
      selectedMember,
      confirmPopup,
      staffColumns,
      filters,
      facilityOptions,
    } = this.state;

    const allowedToAddStaff =
      isPrimaryAdmin(loggedUser) || isSuperAdmin(loggedUser);

    return (
      <Col md={12} lg={12} className="manage-staff-container admin-container">
        <Card>
          <CardBody>
            <div className="sticky-table">
              <HeadingText text="Staff" />
              <div className="row search">
                <div className="col-sm-6">
                  <div className="form__form-group">
                    <Label for="exampleSelect" className="empty-label">
                      &nbsp;
                    </Label>
                    <div className="staff-toolbar-row">
                      <StandardTableToolbar
                        searchValue={filters.search}
                        onSearchChange={this.handleSearch}
                        sortField={filters.sortField}
                        sortOrder={filters.sortOrder}
                        onSortChange={this.handleToolbarSort}
                        sortOptions={getStaffSortOptions({
                          isSuperAdmin: isSuperAdmin(loggedUser),
                        })}
                        filters={{
                          facilities: filters.facilities,
                          designation: filters.designation,
                          type: filters.type,
                          privateCredentials: filters.privateCredentials,
                          status: filters.status,
                        }}
                        onFilterChange={this.handleToolbarFilter}
                        onClearAllFilters={this.handleClearAllToolbarFilters}
                        filterCategories={getStaffFilterCategories({
                          designations: designationAll,
                          facilities: isSuperAdmin(loggedUser)
                            ? facilityAll
                            : [],
                        })}
                        filterSearchThreshold={STAFF_FILTER_SEARCH_THRESHOLD}
                      />
                      {allowedToAddStaff && (
                        <button
                          type="button"
                          className="staff-add-staff-btn"
                          onClick={this.toggle}
                        >
                          Add Staff
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <StaffTableComponent
              sortField={filters.sortField}
              sortOrder={filters.sortOrder}
              heads={staffColumns}
              rows={staff}
              handleGridSort={(field) => this.handleGridSort(field)}
              handleGridFilter={(header, field) =>
                this.handleGridFilter(header, field)
              }
              viewProfile={(field) => this.viewProfile(field)}
              handleActiveStatus={
                allowedToAddStaff ? this.handleActiveStatus : undefined
              }
            />
            <Pagination
              nextPage={this.nextPage}
              prevPage={this.prevPage}
              handlePageLimit={(limit) => this.handlePageLimit(limit)}
              gotoPage={(i) => this.gotoPage(i)}
              limit={filters.limit}
              offset={filters.offset}
              total={filters.total}
            />
          </CardBody>
        </Card>
        <AddNewStaffModal
          isOpen={this.state.modal}
          onClose={this.closeModal}
          onSubmit={this.onSubmit}
          successResponse={successResponse}
          errorResponse={errorResponse}
        />
        <ViewStaff
          selectedId={selectedId}
          selectedMember={selectedMember}
          view={viewPopup}
          data={{ facilityOptions }}
          onClose={this.closeViewStaff}
          onRemove={(id, name) =>
            this.handleActiveStatus('removed', id, name)
          }
          onResendInvite={(id, name) =>
            this.handleActiveStatus('reinvite', id, name)
          }
        />
        <MessageModal
          show={confirmPopup.showResponse}
          type={confirmPopup.responseType}
          alertType={confirmPopup.responseAlertType}
          footer={confirmPopup.footer}
          onSuccess={this.onSuccess}
          onClose={this.closePopup}
          message={confirmPopup.responseMessage}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  currentFacility: state.user?.profile?.facility,
  designationAll: state.staff.designationAll,
  newStaffResponse: state.staff.newStaffResponse,
  newStaffErrorResponse: state.staff.newStaffErrorResponse,
  staffList: state.staff.staffList || {},
  facilityAll: state.staff.facilityAll,
  staffReinviteStatus: state.staff.staffReinviteStatus,
  staffUpdateStatus: state.staff.staffUpdateStatus,
  updateStaffResponse: state.staff.updateStaffResponse,
  common: state.common,
});

const mapDispatchToProps = {
  getStaffList,
  getAllFacilities,
  getAllDesignations,
  addNewStaffMember,
  updateStaffStatus,
  toggleMessageModel,
  reinviteStaff,
  toggleLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
